import { CALENDAR } from "./apiConstant";
import BaseApi from "./baseApi";

class CalendarApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_PROJECT_MANAGEMENT_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  getCalendar(param) {
    return this.post(`${CALENDAR}`, param);
  }

  create(param) {
    return this.post(`${CALENDAR}/create`, param);
  }

  update(param) {
    return this.post(`${CALENDAR}/update`, param);
  }

  deleteItem(param) {
    return this.delete(`${CALENDAR}/${param}`);
  }
}

export default CalendarApi;
